// extracted by mini-css-extract-plugin
export var bodyRow = "_ck-d";
export var cardColumns = "_ck-e";
export var ellipsesOverflow = "_ck-2";
export var flatBottomCorners = "_ck-3";
export var flatTopCorners = "_ck-4";
export var headerActionsDropdown = "_ck-f";
export var headerBottomRow = "_ck-c";
export var headerTopRow = "_ck-b";
export var orderDetailsWrapper = "_ck-0";
export var orderInfoContainer = "_ck-1";
export var productDetails = "_ck-9";
export var productImage = "_ck-5";
export var responsiveTable = "_ck-8";
export var shipmentContainer = "_ck-a";
export var tableBottomLeft = "_ck-6";
export var tableBottomRight = "_ck-7";
export var trackingLink = "_ck-g";